import { ArrowLeft } from 'lucide-react'
import { ButtonIcon, FormHeading } from 'twyne-new.ui';

import history from '@/utils/history'

import ButtonCollapse from './ButtonCollapse';

export default function HeaderContainerForm({ children, ...props }) {
  return <>
    <FormHeading
      {...props}
      sidebarCollapseButton={<>
        <ButtonCollapse />
        <ButtonIcon className='md:hidden' onClick={() => history.goBack()}>
          <ArrowLeft size={20} />
        </ButtonIcon>
      </>}
    >
      {children}
    </FormHeading>
  </>
}
